import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getRoles } from "../../actions/userActions/roleAction";
import "./Roles.css";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import DynamicTable from "../reuse_components/DynamicTable";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import SearchInput from "../subComponents/search/SearchInput";
import CustomButton from "../subComponents/buttons/CustomButton";
import AddRoles from "./AddRoles";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";

function Roles() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1)
  const [isExpanded, setIsExpanded] = useState(false);
  const [previousQuery, setPreviousQuery] = useState("");
  const [query, setQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [RoleData, setRoleData] = useState([]);
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  useEffect(() => {
    dispatch(getRoles());
  }, []);
  const roles = useSelector((state) => state.roles_reducer.roles);

  const totalPages = roles?.totalPages || 0;

  const totalItems = roles?.totalCount || 0;
  const rolesResultData = roles && roles.result;
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));

  const isLoading = useSelector((state) => state.roles_reducer.isRolesLoading);

  const handleAddRoleClick = () => {
    history.push('/admin/AddRoles');
  };
  useEffect(() => {
    const pageNumber = currentPage;
  
      if (query !== previousQuery) {
        setCurrentPage(1);
      }
      dispatch(getRoles(pageNumber, SIZE_OF_PAGE, query));
      setPreviousQuery(query);
  
    }, [currentPage, query]);
  
  const handlePageChange = (page) => {
    setCurrentPage(page);
    history.push(`?page=${page}&search=${query}`);
  };
  useEffect(() => {
    const rolesData = rolesResultData?.map((roles) => ({
      ...roles,
      status: (
        <span className={roles.active ? "status-badge-active" : "status-badge-inactive"}>
          {roles.active ? "Active" : "Inactive"}
        </span>
      )
    }));
    setRoleData(rolesData);
  }, [roles]);
 
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
    { label: `${t("status")}`, accessor: "status" },  
  ];
  
const handleEditRole = (row) => {
  console.log("callling handle edit role");
  
  setEditData(row);
  setShowModal(true);
};
  const actions = [  
    {
        label: 'Edit Role',
        icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
        permission: 'CanUpdateRole',
        handler:handleEditRole,
    },
];

const handleSearchChange = (e) => {
  setQuery(e.target.value);
  setCurrentPage(1);
};
const handleAddClick = () => {
  setEditData(null);
  setShowModal(true);
};


const handleCloseModal = () => {
  setShowModal(false);
};
const handleItemsPerPageChange = (value) => {
  const pageNumber = firstPage;
  dispatch(getRoles(pageNumber, value, query));
  setItemsPerPage(value);
  setCurrentPage(1);
};
const handleSaveData = async () => {
  setShowModal(false);
  await dispatch(getRoles(currentPage, itemsPerPage, query));
  
};

  return (
    <>
    <div>
      <LoadingOverlay isVisible={isLoading} />
    <div className="main-container">
             <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearchChange}
                        value ={query}
             />
                 <div className="flex-align-center">
                 <div className="items-per-page-container">
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                        <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
                       {permissions && permissions.includes("CanAddRole") && (
                            <CustomButton text={t("addNew")} onClick={handleAddClick} />
                        )}
                    </div>
                </div>
            </div>
            
            <DynamicTable
                    data={ RoleData}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                    showPagination={totalItems > 0}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
        </div>
        {showModal && (
        <AddRoles
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
    </div>
        
    
    </>
  );
}

export default Roles;
